if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
        const observer = new MutationObserver((MutationList) => {
            // console.log(MutationList)
            for (let item of MutationList) {
                if (item.target.classList.contains('modal-content')) {
                    document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`));
                    setTimeout(() => {
                        initVariantObserver('[bss-b2b-quickview-product-form]');
                    }, 1000)
                   
                }
                if (item.target.classList.contains('cart-item__total')) {
                    BSS_B2B.observer.cartSubject.listenCartCheckout()
                }                
            }
        })
        observer.observe(document.body, {
            childList: true,
            subtree: true
        })
    }, 300)

    function initVariantObserver(formSelector) {
        const variantInputs = document.querySelectorAll(`${formSelector} .product-variant__container input[type='radio']`);

        if (variantInputs.length) {
            variantInputs.forEach(item => {
                item.addEventListener('click', (e) => {
                    const productForm = document.querySelector(formSelector);
                    BSS_B2B.observer.productSubject.notifyObserver(
                        'VariantChange',
                        'VariantSelectChange',
                        { event: e, productForm }
                    );
                });
            });
        }
    }

    
    setTimeout(() => {
        addB2BAttributes();
        initVariantObserver('[bss-b2b-main-product-form]');
    }, 1500)

    function addB2BAttributes() {
        const elements = document.querySelectorAll(".pf-slide [data-product-type='price'][data-product-id]");
        
        elements.forEach(el => {
            const productId = el.getAttribute("data-product-id");
            if (productId) {
                el.setAttribute("bss-b2b-product-id", productId);
                el.setAttribute("bss-b2b-product-price", "");
            }
        });
        handleCartDrawerFooterMutation();
    }

    async function handleCartDrawerFooterMutation() {
    if (BSS_B2B) {
        const res = await BSS_B2B.storage.productStorage.load();
        if (res) {
            if (res.notExistProductIds?.length || res.productIds?.length || res.variantIds?.size) {
                BSS_B2B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', {
                ...res
                });
            }
        }
    }
    }

}

